import coreStore from "./core-store";
const remoteResource = 'auth/api/v1/users';

const store = coreStore.createCoreStore('user', remoteResource);

export default store;